// deploy-trigger (feat/frontend-import-ui): no-op para forzar el redeploy de PROD del
// frontend al mergear con auto-deploy ON (main HEAD: página Importar datos + refresh en
// descargas/subidas). Sin cambio de comportamiento.
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { ToastHost } from './ui/ToastHost';
import './index.css';

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    // Fix 2026-07-22: MODE es 'production' en TODO build de Vite — staging se
    // disfrazaba de prod. VITE_SENTRY_ENVIRONMENT viene del build (ARG en el
    // Dockerfile, regla Turnstile); fallback al MODE de siempre.
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0, // sin session replay por ahora (cuesta cuota)
    replaysOnErrorSampleRate: 0.1, // grabar replay solo en errores
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    beforeSend(event) {
      // Filtrar errores conocidos del navegador (no son bugs nuestros)
      const msg = event.exception?.values?.[0]?.value ?? '';
      if (msg.includes('ResizeObserver loop')) return null;
      if (msg.includes('Non-Error promise rejection')) return null;
      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    {/* 🔴 Nada falla en silencio: toasts globales de errores de mutación (portal a body). */}
    <ToastHost />
  </React.StrictMode>,
);
